/**
 * AnimatedContainer Component
 * Wrapper that applies animation CSS on mount
 */

import React from 'react';
import clsx from 'clsx';
import './animations.css';

export type AnimationType = 'fadeIn' | 'slideUp' | 'scaleIn' | 'fadeSlideUp';

export interface AnimatedContainerProps {
  children: React.ReactNode;
  animation?: AnimationType;
  delay?: number;
  duration?: number;
  className?: string;
}

export const AnimatedContainer: React.FC<AnimatedContainerProps> = ({
  children,
  animation = 'fadeIn',
  delay = 0,
  duration = 0.3,
  className,
}) => {
  const animationClass = `ai360-animate-${animation}`;

  return (
    <div
      className={clsx(animationClass, className)}
      style={{
        '--delay': `${delay}s`,
        '--duration': `${duration}s`,
      } as React.CSSProperties}
    >
      {children}
    </div>
  );
};
